module.exports = {
  envConfig: {
    routerPrefix: "",
    baseURL: "https://partners.threesoft.cn/api",
    epcURL: "https://erp.threesoft.cn"
  }
};
